import { SocieteEspaceFamilleSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteEspaceFamilleModel: SelectorModel = {
  name: 'societeEspaceFamilles',
  getSelector: SocieteEspaceFamilleSelectors.selectAllSocieteEspaceFamillesDictionary,
  isReady: SocieteEspaceFamilleSelectors.selectIsReadySocieteEspaceFamille
};
